import type { BreakoutDefinition } from '../types';

/**
 * Get Off the Grid — 7-day Breakout for Apps focus.
 * First vertical slice: proves the behaviour engine without clinical content.
 */
export const GET_OFF_THE_GRID: BreakoutDefinition = {
  id: 'breakout_get_off_the_grid',
  slug: 'get-off-the-grid',
  title: 'Get Off the Grid',
  durationDays: 7,
  focusAreaIds: ['apps'],
  tagline: 'Interrupt the open-scroll-close loop. Reclaim the hours.',
  safetyClass: 'standard',
  stages: [
    {
      id: 'stage_notice',
      dayStart: 1,
      dayEnd: 2,
      title: 'Notice',
      intent: 'See the loop without fighting it yet.',
    },
    {
      id: 'stage_interrupt',
      dayStart: 3,
      dayEnd: 5,
      title: 'Interrupt',
      intent: 'Put friction between urge and open.',
    },
    {
      id: 'stage_replace',
      dayStart: 6,
      dayEnd: 7,
      title: 'Replace',
      intent: 'Give the hands something better to do.',
    },
  ],
  moves: [
    {
      id: 'gotg_d1',
      stageId: 'stage_notice',
      day: 1,
      title: 'Name the pull',
      body: 'Next time you open a hookup app, pause for three seconds and say out loud what you wanted when you unlocked the phone. Not the story — the itch.',
      why: 'You cannot interrupt a loop you only notice after it is already running.',
      effort: 'low',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d2',
      stageId: 'stage_notice',
      day: 2,
      title: 'Count without judging',
      body: 'Track how many times you open the app today. No shame, no target. Just the number. Write it once before bed.',
      why: 'A number is cleaner than a story. It shows the real load.',
      effort: 'low',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d3',
      stageId: 'stage_interrupt',
      day: 3,
      title: 'Add one wall',
      body: 'Put the app behind one extra step: log out, move it off the home screen, or use app limits. One wall only. Keep it boring.',
      why: 'Friction buys the three seconds your better self needs.',
      effort: 'medium',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d4',
      stageId: 'stage_interrupt',
      day: 4,
      title: 'Urge → body first',
      body: 'When the urge hits, stand up and change rooms before you open anything. Thirty seconds. Phone stays where it is.',
      why: 'Moving your body breaks the automatic hand-to-screen path.',
      effort: 'low',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d5',
      stageId: 'stage_interrupt',
      day: 5,
      title: 'Protected hour',
      body: 'Pick one hour tonight with zero hookup apps. Put the phone in another room or face-down on charge. Do anything else.',
      why: 'A protected hour proves you can choose the night, not the feed.',
      effort: 'medium',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d6',
      stageId: 'stage_replace',
      day: 6,
      title: 'Replace the first open',
      body: 'Tomorrow morning, the first time you would open the app, do a 5-minute replacement instead: walk, message a real person, or make the bed. Then decide.',
      why: 'Replacement beats willpower. The first open of the day sets the loop.',
      effort: 'medium',
      safetyClass: 'standard',
    },
    {
      id: 'gotg_d7',
      stageId: 'stage_replace',
      day: 7,
      title: 'Write the rule that kept you',
      body: 'Write one personal rule that actually worked this week. Keep it short. Pin it as your default when you are close to opening again.',
      why: 'Your rule beats a generic tip. Momentum needs a line you trust.',
      effort: 'low',
      safetyClass: 'standard',
    },
  ],
};
